module.exports = __webpack_public_path__ + "img/icon-message.a764d8fc.svg";